var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconElectric(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.98984 18H2.99143L3.98984 11H0.495416C-0.0836591 11 -0.0736751 10.68 0.116022 10.34C0.305719 10 0.165942 10.26 0.185911 10.22C1.47385 7.94 3.41076 4.54 5.98665 0H6.98506L5.98665 7H9.48107C9.97029 7 10.0402 7.33 9.95032 7.51L9.88043 7.66C5.94671 14.55 3.98984 18 3.98984 18Z",
    fill: "#FDA536"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconElectric);
export default __webpack_public_path__ + "static/media/icon-electric.39e71041fa667024d84e4541cd855f22.svg";
export { ForwardRef as ReactComponent };